import React from 'react';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { BettingContext } from 'app/contexts/betting';
import $betting from 'app/contexts/betting/$matchoftheday';
import { useFeatureFlag } from 'app/lib/feature-flags';
import Live from 'app/modules/Live/LiveDeferred';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import InterestingMatches from './InterestingMatches';
import MatchOfTheDay from './MatchOfTheDay';
import { MiniBanners } from './MiniBanners';

import styles from './LandingPage.module.scss';

const LandingPageContent = () => {
  const isAllowBanners = useFeatureFlag(FeatureFlag.ALLOW_BANNERS);

  return (
    <div className={styles.content}
         data-test="landingPage-content">
      <div className={styles.scrollable}
           data-test="landingPage-scrollable">

        {isAllowBanners && (
          <>
            <MiniBanners className={styles.bannerList1} />

            <ErrorBoundary>
              <section className={styles.matchOfTheDay}>
                <BettingContext.Provider value={$betting}>
                  <MatchOfTheDay />
                </BettingContext.Provider>
              </section>
            </ErrorBoundary>
          </>
        )}

        <ErrorBoundary>
          <InterestingMatches />
        </ErrorBoundary>
      </div>

      <Live />
    </div>
  );
};

export default LandingPageContent;
